<script>
import { ref, onMounted } from 'vue';
import axiosInstance from '@/axiosConfig';
import { serverUrl } from '@/serverUrl';
import Swal from 'sweetalert2';

export default {
  name: 'NewsPage',

  setup() {
    const fileInput = ref(null);
    const files = ref([]);
    const imagePreviews = ref([]);
    const newsTitle = ref('');
    const newsText = ref('');
    const newsDate = ref('');
    const newsAuthor = ref('');
    const newsList = ref([]);

    const fetchNews = async () => {
      try {
        const response = await axiosInstance.get('/upload/news');
        newsList.value = response.data;
      } catch (error) {
        console.error('Errore nel recupero delle news:', error);
      }
    };

    const handleDrop = (event) => {
      event.preventDefault();
      const droppedFiles = event.dataTransfer.files;
      handleFiles(droppedFiles);
    };

    const openFileManager = () => {
      fileInput.value.click();
    };

    const handleFiles = (selectedFiles) => {
      for (let i = 0; i < selectedFiles.length; i++) {
        files.value.push(selectedFiles[i]);
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreviews.value.push({ url: e.target.result });
        };
        reader.readAsDataURL(selectedFiles[i]);
      }
    };

    const onFileChange = (event) => {
      const selectedFiles = event.target.files;
      handleFiles(selectedFiles);
    };

    const removeImage = (index) => {
      files.value.splice(index, 1);
      imagePreviews.value.splice(index, 1);
    };

    const publishNews = async () => {
      const formData = new FormData();
      formData.append('titolo', newsTitle.value);
      formData.append('testo', newsText.value);
      formData.append('dataNews', newsDate.value);
      formData.append('autore', newsAuthor.value);

      for (let i = 0; i < files.value.length; i++) {
        formData.append('immagini', files.value[i]);
      }

      try {
        const response = await axiosInstance.post('/upload/news', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log('News pubblicata con successo:', response.data);
        Swal.fire('Successo!', 'La news è stata pubblicata con successo.', 'success');
        resetForm();
        fetchNews(); // Aggiorna l'elenco delle news dopo la pubblicazione
      } catch (error) {
        console.error('Errore nel caricamento della news:', error);
        Swal.fire('Errore!', 'Si è verificato un errore durante la pubblicazione della news.', 'error');
      }
    };

    const deleteNews = async (newsId) => {
      Swal.fire({
        title: 'Sei sicuro?',
        text: "Questa operazione non può essere annullata!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sì, elimina!',
        cancelButtonText: 'Annulla'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axiosInstance.delete(`/upload/news/${newsId}`);
            console.log('News eliminata con successo:', response.data);
            Swal.fire('Eliminata!', 'La news è stata eliminata con successo.', 'success');
            fetchNews(); // Aggiorna l'elenco delle news dopo l'eliminazione
          } catch (error) {
            console.error('Errore nell\'eliminazione della news:', error);
            Swal.fire('Errore!', 'Si è verificato un errore durante l\'eliminazione della news.', 'error');
          }
        }
      });
    };

    const resetForm = () => {
      newsTitle.value = '';
      newsText.value = '';
      newsDate.value = '';
      newsAuthor.value = '';
      files.value = [];
      imagePreviews.value = [];
    };

    const formatDate = (dateString) => {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('it-IT', options);
    };

    onMounted(() => {
      fetchNews(); // Carica le news all'avvio del componente
    });

    return {
      fileInput,
      newsTitle,
      newsText,
      newsDate,
      newsAuthor,
      handleDrop,
      openFileManager,
      onFileChange,
      publishNews,
      imagePreviews,
      removeImage,
      newsList,
      deleteNews,
      formatDate,
      serverUrl
    };
  }
};
</script>


<template src="./NewsPage.html"/>

<style scoped></style>